import { BookingGenqlSelection } from '@rematter/frontend-lib-api-client';

// 🟢🟢🟢 SIMPLE LOAD
export const simpleBookingFragment = {
  id: true,
  documentNumber: true,
  vesselArrivalDate: true,
  vesselName: true,
  status: true,
  internalNotes: true,
  // TODO: update api -> add missing fields:
  // account: { ...simpleAccountFragment }
  salesOrders: {
    id: true,
    documentNumber: true,
  },
} satisfies BookingGenqlSelection;

// 🟢🟢🟢 FULL LOAD
export const fullBookingFragment = {
  ...simpleBookingFragment,
  externalNotes: true,
  files: {
    __scalar: true,
    metadata: true,
  },
} satisfies BookingGenqlSelection;
